import React from 'react'
import { accessImage, buttonImage, cameraImage, locationImage, microphoneImage, mobilescreen1, mobilescreen2, mobilescreen3, warning } from '../../../images/images'
import './AllowAccess.css'

function AllowAccess({ popUpMsg, popUpMsgType }) {
    return (
        <div>
            <div>

                {popUpMsgType == "NotReadableError" ? <>
                    <div className='allow-access-container'>
                        <div className='image-container'>
                            <img src={warning} />
                        </div>
                        <p className='allow-access-head-container'>
                            {popUpMsg}
                        </p>
                    </div>

                </> :
                    <div className='allow-access-container'>
                        <p className='allow-access-head'>

                            {popUpMsgType == 'NotAllowedError' ? <>{popUpMsg}</> : <>Please allow Camera access in browser</>}                    </p>
                        <div className='allow-access-steps'>

                            <p>1. Click on the 3 dots on top right corner of Browser.</p>
                            <p>2. Click on settings from dropdown.</p>
                            <img src={mobilescreen1} alt="mobilescreen1" />
                            <p>3. Click on Site Settings in Advanced section.</p>
                            <img src={mobilescreen2} alt="mobilescreen2" />
                            <p>4. Click on Camera  {popUpMsgType == "NotAllowedError" ? <>and microphone</> : null} and give access.</p>
                            <img src={mobilescreen3} alt="mobilescreen3" />
                        </div>
                        <hr />
                        <p className='allow-access-head'>
                            Please enable Pop-ups in browser.
                        </p>
                        <div className='allow-access-steps'>

                            <p>1. Go to site setting as above</p>
                            <p>2. Click on Pop-ups and redirect and enable Pop-ups</p>
                        </div>
                        <hr />
                        <p className='allow-access-head'>
                            Clear blocked sites.
                        </p>
                        <div className='allow-access-steps'>

                            <p>1. Go to Camera {popUpMsgType == "NotAllowedError" ? <>and microphone</> : null} from Site Settings as above</p>
                            <p>2. You can see if any link is blocked</p>
                            <p>3. Long tap on the blocked link</p>
                            <p>4. Click on Clear and reset</p>

                        </div>
                        <p className='reload-text'> After following above steps, please reload the page.</p>


                    </div>
                }
            </div>

        </div>
    )
}

export default AllowAccess